import { BarModule as BarModuleStruct, BarModuleState } from '@/Store/interfaces/bar';

const BarModule: BarModuleStruct = {
  state: {
    barColor: 'rgba(30, 30, 30, 1), rgba(30, 30, 30, 1)',
    barImage: '',
  },
  mutations: {
    SET_BAR_IMAGE(state: BarModuleState, payload: string): void {
      state.barImage = payload
    },
    SET_SCRIM(state: BarModuleState, payload: string): void {
      state.barColor = payload
    },
  },
}

export default BarModule
